export const checklist = [
  {
    id: 'eigentum',
    shortTitle: 'Eigentum an Automatisierungen',
    title: 'Deine Automatisierungen gehören dir – nicht der Agentur',
    problem:
      'Viele Agenturen bauen die Automatisierungen auf ihren eigenen Servern. Kündigst du, fallen sie weg – und dein CRM funktioniert nicht mehr. Das ist kein Versehen, sondern künstliche Kundenbindung. Die meisten Kunden fragen gar nicht nach, weil sie es für selbstverständlich halten. Dabei ist dein CRM Teil deines Unternehmenswerts – spätestens wenn du verkaufen willst.',
    questions: [
      'Laufen alle Automatisierungen auf Servern und Accounts, deren Owner ich bin?',
      'Ist die Agentur dort nur als Admin eingetragen?',
      'Können wir das schriftlich im Vertrag festhalten?',
    ],
    ourAnswer:
      'Alle Automatisierungen laufen auf Accounts, die dir gehören. Wir verwalten sie nur als Admin.',
  },
  {
    id: 'erfahrung',
    shortTitle: 'Mindestens 100 Projekte',
    title: 'Nachweisbare Erfahrung: mindestens 100 umgesetzte Projekte',
    problem:
      'Mit KI glauben viele, sie könnten Close jetzt auch für andere einrichten. Ohne echte Praxis entstehen Automatisierungen, die brechen, sobald mehr Leads reinkommen, ständig nachgebessert werden müssen und nicht auf Skalierung ausgelegt sind. Das ist der häufigste Grund für Unzufriedenheit, den wir von wechselnden Kunden hören.',
    questions: [
      'Wie viele Close-Systeme habt ihr bereits umgesetzt?',
      'Seit wann seid ihr auf Close spezialisiert?',
      'Was passiert mit den Automatisierungen, wenn sich mein Lead-Volumen verdoppelt?',
    ],
    ourAnswer:
      'Seit über 5 Jahren auf Close spezialisiert, über 150 implementierte Systeme – der zweitlängste Close-Partner am Markt.',
  },
  {
    id: 'kundenfokus',
    shortTitle: 'Kundenfokus statt Skalierung',
    title: 'Wer betreut dich wirklich – und mit welcher Priorität?',
    problem:
      'Manche Agenturen wollen vor allem wachsen: großes Werbebudget, Fokus auf Neukunden, der Founder längst raus aus dem Tagesgeschäft. Am Anfang läuft es noch. Nach dem Setup wirst du zum Bestandskunden – und wenn du nicht ständig nachhakst, passiert nichts mehr.',
    questions: [
      'Wer ist nach dem Kickoff mein konkreter Ansprechpartner?',
      'Ist der Founder noch operativ involviert?',
      'Wie viele Kunden betreut ihr gleichzeitig – gibt es eine Obergrenze?',
    ],
    ourAnswer:
      'Unser Werbebudget ist null. Fast alle Kunden kommen über Empfehlungen – deshalb nehmen wir nur so viele Kunden an, wie wir wirklich perfekt betreuen können.',
  },
  {
    id: 'kommunikation',
    shortTitle: 'Schnelle Kommunikation',
    title: 'Support, der nicht nur antwortet, sondern löst',
    problem:
      'Im Vertrieb zählt jede Stunde. Trotzdem landen Anfragen oft in komplizierten Ticketsystemen mit Prioritätsfeldern, bei Chatbots oder bei einem überlasteten Supportteam, das sich nach sechs Stunden meldet – wenn das Problem längst Umsatz gekostet hat.',
    questions: [
      'Über welche Kanäle erreiche ich euch – auch meine Vertriebler direkt?',
      'Wie schnell wird ein Problem nicht nur beantwortet, sondern behoben?',
      'Seid ihr auch am Wochenende erreichbar?',
    ],
    ourAnswer:
      'Eine eigene Gruppe in Slack, WhatsApp oder Telegram für Teamleitung und Vertrieb. Mo–So von 9 bis 21 Uhr erreichbar.',
  },
  {
    id: 'dashboards',
    shortTitle: 'Dashboards & individuelles Setup',
    title: 'Dashboards, die stimmen – und ein Setup, das zu dir passt',
    problem:
      'Close ist kein perfektes Reporting-Tool. Mit KI zaubert heute jeder schicke Dashboards – entscheidend ist, ob die Zahlen korrekt sind und sich an deine KPIs anpassen lassen. Genauso beim Setup: Copy-Paste-Vorlagen, „in zwei Tagen fertig“, ohne Rücksicht auf deine Produkte, Zielgruppen oder deinen Prozess (Setting/Closing, One-Call-Close).',
    questions: [
      'Kann ich jeden Deal bis zur Marketingquelle und Anzeige zurückverfolgen?',
      'Lassen sich die Dashboards an meine individuellen KPIs anpassen?',
      'Gibt es vor dem Setup eine Analyse mit schriftlichem Report?',
    ],
    ourAnswer:
      'Zwei Spezialisten, die seit 3 Jahren ausschließlich Dashboards bauen. Jedes Setup startet mit Kickoff, Analyse und einem Report mit konkreten Vorschlägen.',
  },
  {
    id: 'proaktivitaet',
    shortTitle: 'Proaktivität',
    title: 'Proaktive Weiterentwicklung statt Stillstand nach dem Go-live',
    problem:
      'Nach dem Go-live wird es bei vielen Agenturen still. Neue Features, Chatbots, Marketing-Automatisierungen, Abschluss- und Finanzierungsprozesse – nichts davon kommt, wenn du es nicht selbst einforderst.',
    questions: [
      'Wie sieht die laufende Betreuung konkret aus?',
      'Wie oft bekomme ich Vorschläge für neue Features oder Verbesserungen?',
      'Wer beobachtet, was sich bei Close ändert – und was das für mich bedeutet?',
    ],
    ourAnswer:
      'Wir kommen mit konkreten Vorschlägen auf dich zu – und setzen sie um, sobald du sie freigibst.',
  },
]
